import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import i18n from './i18n'
import { initializeApp } from "firebase/app"
import Swal from 'sweetalert2'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css"
import 'sweetalert2/dist/sweetalert2.min.css'
import "@/assets/css/custom.css"

let firebaseConfig = require("../fbConfig.json")

export const fireApp = initializeApp(firebaseConfig)

const app = createApp(App)
  .use(router)
  .use(i18n)

// Provide SweetAlert2 via Vue global properties so components can inject it
app.config.globalProperties.$swal = Swal

app.mount('#app')

// Signal the prerenderer once the initial route has rendered (and head flushed).
router.isReady().then(() => {
  setTimeout(() => document.dispatchEvent(new Event('render-event')), 0)
})
